import { kml } from "@tmcw/togeojson";
import area from "@turf/area";

// Collect every polygon from any GeoJSON structure.
// MultiPolygons are split so each part is compared individually.
const extractPolygons = (geojson) => {
  const out = [];
  const walk = (g) => {
    if (!g) return;
    switch (g.type) {
      case "FeatureCollection":
        g.features.forEach(walk);
        break;
      case "Feature":
        walk(g.geometry);
        break;
      case "GeometryCollection":
        g.geometries.forEach(walk);
        break;
      case "Polygon":
        out.push({ type: "Feature", properties: {}, geometry: g });
        break;
      case "MultiPolygon":
        g.coordinates.forEach((coords) =>
          out.push({
            type: "Feature",
            properties: {},
            geometry: { type: "Polygon", coordinates: coords },
          }),
        );
        break;
      default:
        break;
    }
  };
  walk(geojson);
  return out;
};

const parseKml = (text) => {
  const doc = new DOMParser().parseFromString(text, "text/xml");
  if (doc.querySelector("parsererror"))
    throw new Error("Fichier KML invalide.");
  return kml(doc);
};

/**
 * Reads a .geojson/.json/.kml file and returns its largest polygon:
 * { feature, area (ha), vertices }
 */
export const importLargestPolygon = async (file) => {
  const ext = file.name.split(".").pop().toLowerCase();
  const text = await file.text();

  let geojson;
  if (ext === "kml") {
    geojson = parseKml(text);
  } else if (ext === "geojson" || ext === "json") {
    try {
      geojson = JSON.parse(text);
    } catch {
      throw new Error("Fichier GeoJSON invalide.");
    }
  } else {
    throw new Error("Format non supporté (GeoJSON ou KML uniquement).");
  }

  const polygons = extractPolygons(geojson);
  if (polygons.length === 0) {
    throw new Error("Aucun polygone trouvé dans le fichier.");
  }

  // pick the biggest by area
  const best = polygons
    .map((feature) => ({ feature, m2: area(feature) }))
    .reduce((a, b) => (b.m2 > a.m2 ? b : a));

  return {
    feature: best.feature,
    area: Math.round((best.m2 / 10000) * 10) / 10, // hectares, 1 decimal
    vertices: best.feature.geometry.coordinates[0].length - 1,
  };
};
export const featureFromCollection = (collection) => {
  const raw = collection?.features?.[0];
  if (!raw?.geometry) throw new Error("Ce feu n'a pas de géométrie.");

  const feature = {
    type: "Feature",
    properties: raw.properties ?? {},
    geometry: raw.geometry,
  };
  return {
    feature,
    area: Math.round((area(feature) / 10000) * 10) / 10, // hectares
  };
};
